// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import flipHorizontalIcon from "@/assets/icons/aop/flip-horizontal.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type FlipHorizontalIconProps = Omit<IconProps, "name">;

export function FlipHorizontalIcon(props: FlipHorizontalIconProps): React.ReactNode {
  return <Icon name={flipHorizontalIcon} {...props} />;
}
